<script setup>
import { XMarkIcon } from "@heroicons/vue/24/solid";
import { DangerButton } from "@codinglabsau/ui";
import ContentCard from "@/Components/Content/ContentCard.vue"

const props = defineProps({
  content: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['remove'])

const removeContent = () => {
  emit('remove', props.content.id)
}
</script>

<template>
  <div class="flex rounded-lg bg-white shadow-md gap-2 h-14 md:h-16 lg:h-24 min-w-0 max-w-full my-0 relative mx-auto">
    <div class="absolute w-full h-full inset-0 bg-white/25 flex items-center z-40">
      <div class="bg-black/60 py-1 px-4 rounded-full text-white text-xs m-5 z-50 mx-auto">{{ __('Preview Only') }}</div>
    </div>
    <div class="hidden sm:block absolute -top-1 -left-2 z-50">
      <DangerButton
        @click.prevent="removeContent"
        type="button"
        class="h-6 w-6 !p-0 !border-0 "
      >
        <XMarkIcon class="w-4 h-4 mx-auto" />
      </DangerButton>
    </div>
    <ContentCard :item="content" />
  </div>
</template>
